// extracted by mini-css-extract-plugin
module.exports = {"carregador":"Carregador_carregador__2QDyV","icone":"Carregador_icone__192S9","small":"Carregador_small__3J0wO"};